import { apiClient } from "../utils";
import { GetNewsletterFormsTranslationsResponse } from "api/models";

export const getNewsletterFormsTranslations = async (shopId: number) => {
  const { data } = await apiClient.get<GetNewsletterFormsTranslationsResponse>(
    `/${shopId}/newsletter-forms/translations`
  );

  return data;
};
